import React from "react";
import Routes from "./Router";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter as Router } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
const App = () => {
  const [auth, setAuth] = React.useState({ authenticated: false, user: null });
  const value = React.useMemo(() => ({ auth, setAuth }), [auth, setAuth]);

  return (
    <Router>
      <AuthContext.Provider value={value}>
        <Routes />
      </AuthContext.Provider>
    </Router>
  );
};
export default App;
